module.exports = __webpack_public_path__ + "static/media/Projets-Villa-Vaud-1.37b100b3.jpg";